import React from 'react';
import { FormattedMessage } from 'react-intl';

import { WhatsappVerificationStep } from '../../../../../components/WhatsappVerification/types';

export const ModalHeaders: Record<WhatsappVerificationStep, React.ReactNode> = {
  [WhatsappVerificationStep.InputNumber]: null,
  [WhatsappVerificationStep.InputOTP]: (
    <FormattedMessage id="text-verify-number" defaultMessage="Verify number" />
  ),
  [WhatsappVerificationStep.ConfirmWhatsappNumber]: null,
  [WhatsappVerificationStep.VerificationSuccess]: (
    <FormattedMessage
      id="text-you-are-subscribed"
      defaultMessage="You are subscribed!"
    />
  ),
} as const;
